import React, { useState, useEffect } from 'react';

interface EditUserModalProps {
  userId?: string;
}

const EditUserModal: React.FC<EditUserModalProps> = ({ userId }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    role: '',
    phone: '',
    address: '',
    status: 'active'
  });

  // TODO: Fetch user data when modal opens
  useEffect(() => {
    if (userId) {
      // Mock data - replace with API call
      setFormData({
        firstName: 'John',
        lastName: 'Doe',
        email: 'john.doe@school.edu',
        role: 'teacher',
        phone: '+1 (555) 123-4567',
        address: '123 Main St, City, State',
        status: 'active'
      });
    }
  }, [userId]);

  const handleSubmit = () => {
    // TODO: Update user API call
    console.log('Updating user:', formData);
  };

  return (
    <div className="modal fade" id="editUserModal">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit User</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">First Name <span className="text-danger">*</span></label>
                  <input 
                    type="text" 
                    className="form-control"
                    value={formData.firstName}
                    onChange={(e) => setFormData({...formData, firstName: e.target.value})}
                    placeholder="Enter first name"
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Last Name <span className="text-danger">*</span></label>
                  <input 
                    type="text" 
                    className="form-control"
                    value={formData.lastName}
                    onChange={(e) => setFormData({...formData, lastName: e.target.value})}
                    placeholder="Enter last name"
                    required
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Email <span className="text-danger">*</span></label>
                  <input 
                    type="email" 
                    className="form-control"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    placeholder="Enter email address"
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Role <span className="text-danger">*</span></label>
                  <select 
                    className="form-select"
                    value={formData.role}
                    onChange={(e) => setFormData({...formData, role: e.target.value})}
                    required
                  >
                    <option value="">Select Role</option>
                    <option value="admin">Admin</option>
                    <option value="teacher">Teacher</option>
                    <option value="student">Student</option>
                    <option value="parent">Parent</option>
                    <option value="support">Support</option>
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Phone Number</label>
                  <input 
                    type="tel" 
                    className="form-control"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    placeholder="Enter phone number"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Status</label>
                  <select 
                    className="form-select"
                    value={formData.status}
                    onChange={(e) => setFormData({...formData, status: e.target.value})}
                  >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                    <option value="suspended">Suspended</option>
                  </select>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Address</label>
                <textarea 
                  className="form-control"
                  rows={3}
                  value={formData.address}
                  onChange={(e) => setFormData({...formData, address: e.target.value})}
                  placeholder="Enter address"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Update Profile Picture</label>
                <input type="file" className="form-control" accept="image/*" />
                <small className="text-muted">Leave empty to keep current picture</small>
              </div>
              <div className="mb-3">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="resetPassword" />
                  <label className="form-check-label" htmlFor="resetPassword">
                    Send password reset email to user
                  </label>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={handleSubmit}>
              <i className="ti ti-device-floppy me-2"></i>Update User
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUserModal;
